import { useLocation, useParams } from "react-router";
import useLocale from "./useLocale";

const useCheckRoutIsHome = () => {
  const { pathname } = useLocation();
  const { navigate } = useLocale();
  const params = useParams();
  const pathLength = pathname.split("/").splice(1).length;
  const isHome = pathname === `/${params.lang}` || pathname === `/${params.lang}/` || pathLength === 1;

  const handleNavigateToHome = () => {
    if (isHome) navigate(`/${params.lang}`);
  };
  return { isHome, handleNavigateToHome };
};

export default useCheckRoutIsHome;
